import {
  getPhoneDigits,
  normalizeRussianLocalPhoneNumber,
} from './normalizeRussianLocalPhoneNumber';

// Only digits and phone mask characters: "+7 (999) 123-45-67", "8 999 123".
const PHONE_LIKE_SEARCH_REGEXP = /^[\d\s()+-]+$/;
// "8 (999…", "8(999…", "8 999…", "8-999…" — a Russian number typed via 8:
// the 8 is followed by a separator and a 3-digit operator code. A fragment
// from the middle of a number ("8-90-12") does not match and stays as is.
const RUSSIAN_LOCAL_PREFIX_REGEXP = /^8[\s(-]+\d{3}/;

// Clients are stored with bare phone digits ("79991234567"), so a search
// term typed with a mask, "+7" or "8" has to be reduced to the same form.
// Non-phone terms (names, emails, etc.) are returned trimmed as is.
export const normalizePhoneSearchTerm = (term: string): string => {
  const trimmedTerm = term.trim();

  if (!PHONE_LIKE_SEARCH_REGEXP.test(trimmedTerm)) {
    return trimmedTerm;
  }

  const phoneDigits = getPhoneDigits(trimmedTerm);

  if (!phoneDigits) {
    return trimmedTerm;
  }

  if (RUSSIAN_LOCAL_PREFIX_REGEXP.test(trimmedTerm)) {
    return `7${phoneDigits.slice(1)}`;
  }

  return normalizeRussianLocalPhoneNumber(phoneDigits);
};

// The clients registry backend strips the mask of a phone itself and also
// matches the term against additional client fields ("4510 123456"), so
// there the term is sent as typed. The backend turns 8 into 7 only for a
// full 11-digit number, so a part of a number typed via 8 ("8 (912) 345")
// is rewritten here.
export const normalizeRussianLocalPhoneSearchTerm = (term: string): string => {
  const trimmedTerm = term.trim();

  if (
    !PHONE_LIKE_SEARCH_REGEXP.test(trimmedTerm) ||
    !RUSSIAN_LOCAL_PREFIX_REGEXP.test(trimmedTerm)
  ) {
    return term;
  }

  return `7${getPhoneDigits(trimmedTerm).slice(1)}`;
};
